import { Box, Card, Typography } from "@mui/material";
import React from "react";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export default function TransmittedDocCard({ row, doc }) {
  return (
    <Card
      key={doc.id}
      sx={{
        m: 1,
        width: "300px",
        backgroundColor: "#f3f1fe",
        position: "relative",
        pb: 3,
      }}
    >
      <Box sx={{ p: 1 }}>
        <Box
          component="a"
          // target="_blank"
          href={process.env.REACT_APP_STATIC + "/api/download-docs/" + doc.path}
          download
          sx={{ width: "300px" }}
        >
          <Card
            sx={{
              cursor: "pointer",
              p: 2,

              width: "100%",
            }}
          >
            {doc.originalName}
            <CloudDownloadIcon
              sx={{
                float: "right",
                color: "primary.main",
                transform: "translateY(-1px)",
              }}
            />
          </Card>
        </Box>

        {doc.comments && doc.comments.length > 0 && (
          <Box
            sx={{
              ml: 1,
              height: "150px",
              overflowY: "auto",
              mt: 1,
            }}
          >
            <Typography variant="subtitle2" sx={{}}>
              Comments:
            </Typography>

            {doc.comments.map((comment, index) => (
              <Typography key={index} variant="body2" sx={{ mt: 0.5, mb: 0.5 }}>
                - {comment}
              </Typography>
            ))}
          </Box>
        )}
        {doc.revisedDoc && (
          <Card
            sx={{
              cursor: "pointer",
              p: 2,
              my: 1,
            }}
          >
            {doc.revisedDoc?.originalName}
            <CloudDownloadIcon
              sx={{
                float: "right",
                color: "primary.main",
                transform: "translateY(-1px)",
              }}
            />
          </Card>
        )}
      </Box>
      <Box
        sx={{
          backgroundColor: doc.isApproved ? "#1DD75BFF" : "gray",
          color: "white",
          textAlign: "center",
          p: 0.5,
          fontSize: "12px",
          position: "absolute",
          bottom: 0,
          width: "100%",
        }}
      >
        {doc.isApproved
          ? "Approved"
          : doc.revisedDoc?.id
          ? "Under Review"
          : "Sent for Review"}
      </Box>
    </Card>
  );
}
